import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import AgreementCheckbox from "../../../controls/AgreementCheckbox";

const StyledRow = styled(Row)`
  .input-label {
    span {
      > span {
        color: #790000;
      }
    }
  }
`;

function AgreementBlock() {
  return (
    <StyledRow>
      <Col xs={12}>
        <div className="input-label">
          <span>Client Agreement <span>*</span></span>
        </div>
      </Col>
      <Col xs={12}>
        <AgreementCheckbox
          id="formAgreement"
          hideDivider
          label={(
            <span>
              By checking this box, I represent and warrant that all of the information provided above is accurate and complete. 
              I authorize EIN Federal Tax ID to act as a “Third Party Designee” as described in the instructions to Form SS-4 to apply for and receive the Employer Identification Number from the IRS. 
              I agree to the Privacy Policy and Terms and Conditions of service and to receive text message updates regarding my order.
            </span>
          )}
        />
      </Col>
    </StyledRow>
  );
}

export default AgreementBlock;
